import React from 'react';
import { CHECKOUT_URL, CTA_LABEL, pricing } from '../data/resinContent';
import { trackPixelEvent } from '../utils/metaPixel';
type CtaButtonProps = {
  /** 'scroll' sends the reader to the offer section, 'checkout' goes straight to payment. */
  target?: 'scroll' | 'checkout';
  size?: 'md' | 'lg';
  className?: string;
  label?: string;
};
export function CtaButton({
  target = 'checkout',
  size = 'lg',
  className = '',
  label = CTA_LABEL
}: CtaButtonProps) {
  const sizeClasses = size === 'lg' ? 'px-4 py-4 text-[12px] tracking-[0.08em] min-[400px]:text-[12.5px] sm:px-8 sm:py-[1.125rem] sm:text-sm sm:tracking-[0.12em]' : 'px-4 py-4 text-[12px] tracking-[0.08em] min-[400px]:text-[12.5px] sm:px-6 sm:text-[13px] sm:tracking-[0.12em]';
  const isCheckout = target === 'checkout';
  return <a href={isCheckout ? CHECKOUT_URL : '#offer'} onClick={isCheckout ? () => trackPixelEvent('InitiateCheckout', {
    content_name: 'RESIN TO PROFIT',
    value: pricing.todayValue,
    currency: 'USD'
  }) : undefined} className={`inline-flex w-full min-w-0 max-w-md items-center justify-center whitespace-nowrap rounded-full bg-champagne text-center font-sans font-semibold uppercase text-charcoal-950 shadow-lift transition-[background-color,transform] duration-150 ease-out hover:-translate-y-0.5 hover:bg-champagne-light focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-champagne active:translate-y-0 ${sizeClasses} ${className}`} data-id="element-76" data-mp="19c37suqwgeyz">
      {label}
    </a>;
}